import styled from '@emotion/styled';
import { Link as PhosphorLink } from '@phosphor-icons/react';

/* Linkable cell - for cells that link to related entities */
export const StyledLinkableCell = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  & > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;

export const StyledLinkableCellText = styled.span`
  font-weight: 700;
  color: ${p => p.theme.palette.text.secondary};
`;

export const CenteredCell = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

/* Link icon - for indicating linked entities */
export const LinkIcon = styled(PhosphorLink)`
  margin-right: ${p => p.theme.s.xs};
  min-width: 16px;
  min-height: 16px;
  vertical-align: top;
  fill: ${p => p.theme.palette.fg.secondary};
`;
